import { useMutation } from "@connectrpc/connect-query";
import { AvailabilityService } from "@viajero/proto/guest/v1";

/**
 * AvailabilityService.CheckAvailability を connect-query mutation でラップするフック。
 *
 * コース詳細画面の「空席確認」押下時に、選択中の利用日・時間・人数で呼び出す (JPTP_CANSEI-1658)。
 * 空席確認は予約サイト操作 Bot を同期 Invoke する重い処理だが、押下のたびに最新の空席状況を
 * 返す必要があるため、キャッシュを持つ useQuery 版 (features/shops/api/useCheckAvailability。
 * 店舗画面のチップ表示用で staleTime 無限) ではなく mutation として実装する。
 * 「空席なし」は正常応答 (available=false) で、Bot 操作の失敗・判定不能はエラーになる。
 */
export function useCheckAvailability() {
  return useMutation(AvailabilityService.method.checkAvailability);
}
